import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./user/userSlice";
import surveySlice from "./survey/surveySlice";
import { langSlice } from "./langSlice";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    survey: surveySlice.reducer,
    lang: langSlice.reducer,
  },
});

//global state type
export type RootState = ReturnType<typeof store.getState>;
//already typed "hook" to dispatch the actions
export const useAppDispatch: () => typeof store.dispatch = useDispatch;
//already typed "hook" to access the state
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
